import { Dumbbell, Briefcase, Cloud, Sparkles } from "lucide-react";
import { GlassCard } from "@/components/GlassCard";
import { useLanguage } from "@/i18n/LanguageContext";

// Only truly future features — community feed, follows and challenges
// are already implemented in Stage 2.1 and must not be listed here.
const FUTURE_FEATURES = [
  { icon: Dumbbell, key: "profile.future1" },
  { icon: Briefcase, key: "profile.future2" },
  { icon: Cloud, key: "profile.future3" },
  { icon: Sparkles, key: "profile.future4" },
];

export const FutureWavesCard = () => {
  const { t } = useLanguage();
  return (
    <GlassCard className="p-4">
      <p className="text-xs font-medium text-[hsl(var(--muted-foreground))] uppercase tracking-wider mb-3">
        {t("profile.futureTitle")}
      </p>
      <div className="space-y-2.5 opacity-55">
        {FUTURE_FEATURES.map(({ icon: Icon, key }) => (
          <div key={key} className="flex items-center gap-3 text-sm">
            <Icon size={15} className="text-cyan-300/70" />
            <span>{t(key)}</span>
          </div>
        ))}
      </div>
    </GlassCard>
  );
};
